<template>
    <div :data-content="event.description" @click="click">
        <div> {{ event.name }}</div>
    </div>
</template>

<script>
export default {
    name: "CalendarEvent",

    props: {
        event: {}
    },

    methods: {
        click() {
            console.log("clicked");
            this.$emit("edit-current-event");
        }
    },

    mounted() {
        // $(this.$el).popup();
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
div {
    display: flex;
    color: white;
    align-items: center;
    justify-content: center;
    min-height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/CheckList/CalendarEvent.vue